// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".questionBtns {\n  border-top: 1.5PX SOLID #E7E7EA;\n  text-align: end;\n  padding: 16px;\n  padding-right: 0;\n}\n\n.new-button .eymp-button.eymp-button-root {\n  max-width: max-content;\n  height: 44px;\n  border: 1px solid transparent;\n  padding-top: 8px;\n}\n.new-button .eymp-button .eymp-button-label {\n  font-size: 14px;\n}\n\n.container-height {\n  min-height: 74vh;\n}\n\n.container-height .MuiDialog-paper {\n  margin-left: 280px !important;\n}", ""]);
// Exports
module.exports = exports;
